// accordion.js
document.addEventListener('DOMContentLoaded', function () {
    var accordions = document.querySelectorAll('.accordion-button');

    accordions.forEach(function (accordion) {
        accordion.addEventListener('click', function () {
            var index = this.getAttribute('data-index');
            var targetCollapse = document.getElementById('collapse-' + index);

            // Toggle the aria-expanded attribute
            var isExpanded = this.getAttribute('aria-expanded') === 'true';
            this.setAttribute('aria-expanded', !isExpanded);

            // Toggle the aria-hidden attribute
            var isHidden = targetCollapse.getAttribute('aria-hidden') === 'true';
            targetCollapse.setAttribute('aria-hidden', !isHidden);

            // Toggle the class to show/hide the content
            targetCollapse.classList.toggle('show');

            // Close other accordions
            closeOtherAccordions(index);
        });
    });

    function closeOtherAccordions(currentIndex) {
        var accordions = document.querySelectorAll('.accordion-button');
        accordions.forEach(function (accordion, index) {
            if (index != currentIndex) {
                accordion.setAttribute('aria-expanded', 'false');
                var targetCollapse = document.getElementById('collapse-' + index);
                targetCollapse.setAttribute('aria-hidden', 'true');
                targetCollapse.classList.remove('show');
            }
        });
    }
});